import {StrongoShipment, type StrongoShipmentData} from "@/types/shipments/Strongo/StrongoShipment.ts";
import {CustomerLedgerEntry, type CustomerLedgerEntryData} from "@/types/erp/customerLedgerEntry.ts";
import {
    StrongoShipmentParcel,
    type StrongoShipmentParcelData
} from "@/types/shipments/Strongo/StrongoShipmentParcel.ts";

export class StrongoInvoice {
    public id: number | null;
    public invoice_id: number | null;
    public no: string;
    public strongoShipment: StrongoShipment | null;
    public strongoShipmentParcel: StrongoShipmentParcel | null;
    public customerLedgerEntry: CustomerLedgerEntry | null;


    constructor(data: StrongoInvoiceData | void) {
        if (data === undefined) {
            this.id = null;
            this.invoice_id = null;
            this.no = "";
            this.strongoShipment = null;
            this.strongoShipmentParcel = null;
            this.customerLedgerEntry = null;

        } else {
            this.id = data.id;
            this.invoice_id = data.invoice_id;
            this.no = data.no;
            this.strongoShipment = null;
            if (data.strongoShipment !== undefined && data.strongoShipment !== null) {
                this.strongoShipment = new StrongoShipment(data.strongoShipment);
            }
            this.strongoShipmentParcel = null;
            if (data.strongoShipmentParcel !== undefined && data.strongoShipmentParcel !== null) {
                this.strongoShipmentParcel = new StrongoShipmentParcel(data.strongoShipmentParcel);
            }
            this.customerLedgerEntry = null;
            if (data.customerLedgerEntry !== undefined && data.customerLedgerEntry !== null) {
                this.customerLedgerEntry = new CustomerLedgerEntry(data.customerLedgerEntry);
            }
        }
    }

}

export type StrongoInvoiceData = {
    id: number | null;
    invoice_id: number | null;
    no: string;
    strongoShipment: StrongoShipmentData | null | undefined;
    strongoShipmentParcel: StrongoShipmentParcelData | null | undefined;
    customerLedgerEntry: CustomerLedgerEntryData | null | undefined;

}